import type { GetArtistCatalogueQuery } from '#lib/websites/artists/queries/__generated__/getArtistCatalogue.generated.js';
import { formatPrice } from '$global/utils/formatPrice';
import { getImageUrl } from '$global/utils/getImageUrl';

type CatalogueMerchItem = GetArtistCatalogueQuery['merchItems'][number];
type CatalogueMerchProduct = NonNullable<CatalogueMerchItem['product']>;
type CatalogueMerchVariationProduct = NonNullable<
	NonNullable<
		NonNullable<CatalogueMerchItem['variations']>[number]
	>['related_Merch_Item_id']
>['product'];

// Only what the cards read, so the REST catalogue's items fit as well as the
// query's. `is_stock_limited` is optional because the REST items carry no such
// field.
type MerchItem = Pick<CatalogueMerchItem, 'title' | 'slug' | 'image'> & {
	product:
		| (Pick<CatalogueMerchProduct, 'price' | 'currency'> &
				Partial<Pick<CatalogueMerchProduct, 'is_stock_limited'>>)
		| null;
	variations: Array<{
		related_Merch_Item_id: {
			product: CatalogueMerchVariationProduct;
		} | null;
	} | null> | null;
};

export const transformCatalogueMerch = (merchItems: MerchItem[] | undefined) =>
	(merchItems || []).map((item) => {
		const variations = item.variations
			?.map((vari) => {
				const variation = vari?.related_Merch_Item_id;
				if (!variation?.product) {
					return null;
				}

				return {
					product: {
						in_stock: variation.product.in_stock,
						price: variation.product.price,
						currency: variation.product.currency,
					},
				};
			})
			.filter((v) => v !== null);

		return {
			title: item.title,
			slug: item.slug,
			product: {
				price: item.product
					? formatPrice(item.product.price, item.product.currency)
					: null,
				in_stock: item.product?.is_stock_limited ? false : true,
			},
			image: {
				url: getImageUrl(item.image?.filename_disk, '513px'),
				width: item.image?.width || 0,
				height: item.image?.height || 0,
			},
			variations,
		};
	});
